import { Flex } from "@gravity-ui/uikit";
import { outline, Scanner } from "@yudiel/react-qr-scanner";
import { useCallback, useState } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice.ts";

import { CertInfoModal } from "../CertInfoModal/CertInfoModal";
import css from "./CertScanner.module.scss";

export const CertScanner = () => {
  const { isMobile } = useGravityDevice();
  const [certNo, setCertNo] = useState<string | null>(null);
  const [isOpenCertInfo, setIsOpenCertInfo] = useState(false);
  const [paused, setPaused] = useState(false);

  const closeCertInfo = useCallback(() => {
    setIsOpenCertInfo(false);
    setCertNo(null);
    setTimeout(() => setPaused(false), 1000);
  }, [setCertNo, setIsOpenCertInfo, setPaused]);

  const openCertInfo = useCallback(
    (certNo: string) => {
      setCertNo(certNo);
      setIsOpenCertInfo(true);
      setPaused(true);
    },
    [setCertNo, setIsOpenCertInfo, setPaused],
  );

  return (
    <Flex justifyContent={isMobile ? "center" : "start"}>
      <Scanner
        classNames={{
          container: css.scannerWrapper,
        }}
        formats={["qr_code"]}
        onScan={(result) => {
          const url = new URL(result[0].rawValue);
          const certNo = url.searchParams.get("certNo");
          if (!certNo) return;
          openCertInfo(certNo);
        }}
        scanDelay={2000}
        allowMultiple
        paused={paused}
        components={{
          torch: true,
          zoom: true,
          finder: true,
          tracker: outline,
        }}
      />
      {certNo && (
        <CertInfoModal
          open={isOpenCertInfo}
          onClose={closeCertInfo}
          certNo={certNo}
        />
      )}
    </Flex>
  );
};
